"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
var translations_1 = require("../../../../utils/translations");
var CustomColorButton = /** @class */ (function (_super) {
    tslib_1.__extends(CustomColorButton, _super);
    function CustomColorButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            _this.props.onClick();
        };
        return _this;
    }
    CustomColorButton.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "gd-color-drop-down-custom-section" },
            react_1.default.createElement(sdk_ui_kit_1.Button, { value: translations_1.getTranslation("gs.color-dropdown.custom-color", this.props.intl), className: "gd-button-link gd-color-drop-down-custom-section-button s-custom-section-button", onClick: this.onClick })));
    };
    return CustomColorButton;
}(react_1.default.PureComponent));
exports.default = react_intl_1.injectIntl(CustomColorButton);
//# sourceMappingURL=CustomColorButton.js.map